import { render, staticRenderFns } from "./layTableHead.vue?vue&type=template&id=3deab1e4&scoped=true"
import script from "./layTableHead.vue?vue&type=script&lang=js"
export * from "./layTableHead.vue?vue&type=script&lang=js"
import style0 from "./layTableHead.vue?vue&type=style&index=0&id=3deab1e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deab1e4",
  null
  
)

export default component.exports